import "babel-polyfill";
import "./libs/slick";
import "./libs/jcf/jcf.js";
import "./libs/jcf/jcf.scrollable.js";
import "./libs/jcf/jcf.select.js";

import {binder} from "./libs/binder";
import {constants} from "./modules/module";
import {fullHeightPage} from "./modules/fullHeightPage";
import {stickyHeader} from "./modules/stickyHeader";
import {mobileNav} from "./modules/mobileNav";
import {postsSlider} from "./modules/postsSlider";
import {cookieInfo} from "./modules/cookieInfo";
import {trustedLogosSlider} from "./modules/trustedLogosSlider";
import {partnershipsSlider} from "./modules/partnershipsSlider";
import {successStoriesSlider} from "./modules/successStoriesSlider";
import {popups} from "./modules/popups";
import {leadershipAnchors} from "./modules/leadershipAnchors";
import {newsSlider} from "./modules/newsSlider";
import {tabs} from "./modules/tabs";
import {video} from "./modules/video";
import {testimonialsSlider} from "./modules/testimonialsSlider";
import {testimonialSliderLanding} from "./modules/testimonialSliderLanding";
import {insertSvgPagination} from "./modules/insertSvgPagination";
import {customSelect} from "./modules/customSelect";
import {moreStoriesSlider} from "./modules/moreStoriesSlider";
import {stickySharing} from "./modules/stickySharing";
import {additionalInfo} from "./modules/additionalInfo";
import {historySlider} from "./modules/historySlider";
import {anchorLink} from "./modules/anchorLink";
import {accordion} from "./modules/accordion";
import {accordionT50} from "./modules/accordionT50";
import {accordionCallout} from "./modules/accordionCallout";
import {successStoriesGallery} from "./modules/successStoriesGallery";
import {subprocessorBox} from "./modules/subprocessorBox.js";
import {expertBio} from "./modules/expertBio.js";
import { thinkers50CTA } from "./modules/thinkers50CTA";

binder({
    bounds: {
        "html": [constants, fullHeightPage],
        ".header": [stickyHeader, mobileNav],
        ".posts-slider": postsSlider,
        ".cookie-info": cookieInfo,
        ".list-partnerships": partnershipsSlider,
        ".trustedpartners .list-partnerships": trustedLogosSlider,
        ".success-stories": successStoriesSlider,
        ".popup-link": popups,
        ".team-wrap": leadershipAnchors,
        ".news-slider": newsSlider,
        ".tabs-holder": tabs,
        ".image-holder": video,
        ".testimonials-slider": testimonialsSlider,
        ".testimonial-landing-slider": testimonialSliderLanding,
        ".pagination": insertSvgPagination,
        "select": customSelect,
        ".slider-more-stories": moreStoriesSlider,
        ".has-share": stickySharing,
        ".additional-info": additionalInfo,
        ".history-slider": historySlider,
        ".anchor-link": anchorLink,
        ".accordion": accordion,
        ".thinkers-cta-section": accordionT50,
        ".success-stories-gallery": successStoriesGallery,
        ".subprocessor-box": subprocessorBox,
        ".expert-bio": expertBio,
        ".accordion-item .accordion-title": accordionCallout,
        ".main": thinkers50CTA
    },
    runTests: false
});

window.initCustomSelect = function () {
    customSelect();
};



// WEBPACK FOOTER //
// ./assets/js/global.js